import { render, staticRenderFns } from "./IrrigationSystemPassport.vue?vue&type=template&id=4b12b6f6&scoped=true"
import script from "./IrrigationSystemPassport.vue?vue&type=script&lang=js"
export * from "./IrrigationSystemPassport.vue?vue&type=script&lang=js"
import style0 from "./IrrigationSystemPassport.vue?vue&type=style&index=0&id=4b12b6f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b12b6f6",
  null
  
)

export default component.exports